export default "__VITE_ASSET__CsEXRByl__"